import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const section = {
  fetchSections: lazyModuleMethod(() => import('./fetchSections'), 'default'),
  fetchSection: lazyModuleMethod(() => import('./fetchSection'), 'default'),
  createSection: lazyModuleMethod(() => import('./createSection'), 'default'),
  updateSection: lazyModuleMethod(() => import('./updateSection'), 'default'),
  deleteSection: lazyModuleMethod(() => import('./deleteSection'), 'default'),
}
